import { push } from "../services/sendEvent";

export const getStartedCtaClicked = (data) => {
    // Call push function with event-label "get_started_cta_clicked" and required payload
    push({
        event_label: "get_started_cta_clicked",
        event_datum: {
            field_information: data
        }
    });
}
